// import { getToken, getUser } from "../../../Helpers/Utils/Common";
// import { getAPICallWithParams, postAPICallwithFile , postAPICall,} from "../axiosMethodCalls"
import { getToken, getUser } from "../../Utilities/Common"
// import { formatYYYYMMDD_HHMM } from "../../../../Helpers/Utils/Common";
import {
  postAPICallwithFile,
  getWithParamsAPICall,
  postAPICall,
  getWithParamsQRAPICall,
} from "../axiosMethodCall"

//POST API -- append a new data to the db
// export const createDiagnostic = async (data) => {
//   try {
//     var formData = new FormData();
//     formData.append("requester", getUser());
//     formData.append("token", getToken()?.replace(/['"]+/g, ""));
//     formData.append("patient_id", data.patient_id);
//     formData.append("assessment_id", data.assessment_id);
//     formData.append("fasting", data.fasting || "");
//     formData.append("notes", data.notes || "");
//     formData.append("case_number", data.case_number || "");
//     formData.append("diagnostic_date", data.diagnostic_date || "");
//     formData.append("last_meal", data.last_meal || "");
//     formData.append("room_number", data.room_number || "");
//     formData.append("chief_complaint", data.chief_complaint || "");
//     formData.append("is_philhealth_member", data.is_philhealth_member || "0");
//     formData.append("doctor_id", data.doctor_id || "");

//     data.lab_test.forEach((info) => {
//       formData.append("lab_names[]", info.name || "");
//       formData.append("lab_test_ids[]", info.id || "");
//     });

//     // data.type.forEach((info) => {
//     //   formData.append("type[]", info || null);
//     // });

//     // data.sub_type.forEach((info) => {
//     //   formData.append("sub_type[]", info || "");
//     // });

//     // data.is_new.forEach((info) => {
//     //   formData.append("is_new[]", info || "");
//     // });

//     const response = await postAPICallwithFile(
//       process.env.REACT_APP_LINK + "diagnostics/create",
//       formData,
//       true
//     );

//     return { data: response.data };
//   } catch (error) {
//     return { error: error.response };
//   }
// };
// export const updateDiagnostic = async (data) => {
//   try {
//     var formData = new FormData();
//     formData.append("requester", getUser());
//     formData.append("token", getToken()?.replace(/['"]+/g, ""));
//     formData.append("patient_id", data.patient_id);
//     formData.append("assessment_id", data.assessment_id);
//     formData.append("diagnostic_id", data.id);
//     formData.append("diagnostic_date", data.diagnostic_date || "");
//     formData.append("last_meal", data.last_meal || "");
//     formData.append("room_number", data.room_number || "");
//     formData.append("chief_complaint", data.chief_complaint || "");
//     formData.append("case_number", data.case_number || "");
//     formData.append("is_philhealth_member", data.is_philhealth_member || "0");
//     formData.append("doctor_id", data.doctor_id || "");

//     formData.append("fasting", data.fasting);
//     formData.append("notes", data.notes);

//     data.lab_test.forEach((info) => {
//       formData.append("lab_names[]", info.name || "");
//       formData.append("lab_test_ids[]", info.id || "");
//     });

//     // data.lab_name.forEach((info) => {
//     //   formData.append("lab_name[]", info || null);
//     //   formData.append("lab_schedule[]", data.diagnostic_date || null);
//     // });
//     // // data.lab_schedule.forEach((info) => {
//     // //   formData.append("lab_schedule[]", info || null);
//     // // });
//     // data.diagnostic_item_id.forEach((info) => {
//     //   formData.append("diagnostic_item_id[]", info || null);
//     // });
//     // data.type.forEach((info) => {
//     //   formData.append("type[]", info || null);
//     // });

//     // data.sub_type.forEach((info) => {
//     //   formData.append("sub_type[]", info || "");
//     // });

//     // data.is_new.forEach((info) => {
//     //   formData.append("is_new[]", info || "");
//     // });

//     const response = await postAPICallwithFile(
//       process.env.REACT_APP_LINK + "diagnostics/update",
//       formData,
//       true
//     );

//     return { data: response.data };
//   } catch (error) {
//     return { error: error.response };
//   }
// };
export const createDiagnostic = async (data) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken()?.replace(/['"]+/g, ""))
    formData.append("patient_id", data.patient_id)
    formData.append("assessment_id", data.assessment_id)
    formData.append("fasting", data.fasting || "")
    formData.append("notes", data.notes || "")
    formData.append("case_number", data.case_number || "")
    formData.append("diagnostic_date", data.diagnostic_date || "")
    formData.append("room_number", data.room_number || "")
    formData.append("chief_complaint", data.chief_complaint || "")
    formData.append("is_philhealth_member", data.is_philhealth_member || "0")
    formData.append("doctor_id", data.doctor_id || "")

    data.lab_name.forEach((info) => {
      formData.append("lab_name[]", info || null)
      formData.append("lab_schedule[]", data.diagnostic_date || "")
    })
    // data.lab_schedule.forEach((info) => {
    //   formData.append("lab_schedule[]", info || null);
    // });

    data.type.forEach((info) => {
      formData.append("type[]", info || null)
    })

    data.sub_type.forEach((info) => {
      formData.append("sub_type[]", info || "")
    })

    data.is_new.forEach((info) => {
      formData.append("is_new[]", info || "")
    })

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "diagnostics/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
export const updateDiagnostic = async (data) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken()?.replace(/['"]+/g, ""))
    formData.append("patient_id", data.patient_id)
    formData.append("assessment_id", data.assessment_id)
    formData.append("diagnostic_id", data.id)
    formData.append("diagnostic_date", data.diagnostic_date || "")
    formData.append("room_number", data.room_number || "")
    formData.append("chief_complaint", data.chief_complaint || "")
    formData.append("case_number", data.case_number || "")
    formData.append("is_philhealth_member", data.is_philhealth_member || "0")
    formData.append("doctor_id", data.doctor_id || "")

    formData.append("fasting", data.fasting)
    formData.append("notes", data.notes)

    data.lab_name.forEach((info) => {
      formData.append("lab_name[]", info || null)
      formData.append("lab_schedule[]", data.diagnostic_date || null)
    })
    // data.lab_schedule.forEach((info) => {
    //   formData.append("lab_schedule[]", info || null);
    // });
    data.diagnostic_item_id.forEach((info) => {
      formData.append("diagnostic_item_id[]", info || null)
    })
    data.type.forEach((info) => {
      formData.append("type[]", info || null)
    })

    data.sub_type.forEach((info) => {
      formData.append("sub_type[]", info || "")
    })

    data.is_new.forEach((info) => {
      formData.append("is_new[]", info || "")
    })

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "diagnostics/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getDiagnostic = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      diagnostic_id: id,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "diagnostics/get",
      payload
    )

    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getLabTestForDiagnostics = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      lab_type: data.lab_type || "",
      search: data.search || "",
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_tests/get_for_diagnostics",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getLabTestForEMRDiagnostics = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      lab_type: data.lab_type || "",
      search: data.search || "",
      origin: "emr",
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_tests/get",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// export const updateDiagnostic = async (
//   info,
//   diagnostics,
//   patient_id,
//   assessment_id
// ) => {
//   try {
//     var formData = new FormData();
//     formData.append("requester", getUser());
//     formData.append("token", getToken().replace(/['"]+/g, ""));
//     formData.append("diagnostic_id", info.id);
//     formData.append("patient_id", patient_id);
//     formData.append("assessment_id", assessment_id);
//     formData.append("fasting", info.fasting);
//     formData.append("others", info.others);
//     diagnostics.forEach((data) => {
//       formData.append("type[]", data.type);
//     });
//     diagnostics.forEach((data) => {
//       formData.append("lab_name[]", data.lab_name);
//     });
//     diagnostics.forEach((data) => {
//       formData.append(
//         "lab_schedule[]",
//         data.lab_schedule ? data.lab_schedule.split("T").join(" ") + ":00" : ""
//       );
//     });

//     // file.map((val) => {
//     //     formData.append("attachments[]", val);
//     // });
//     const response = await postAPICallwithFile(
//       process.env.REACT_APP_LINK + "diagnostics/update",
//       formData
//     );

//     return { data: response };
//   } catch (error) {
//     return { data: error.response.data };
//   }
// };

export const deleteDiagnostic = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "diagnostics/delete",
      {
        requester: getUser(),
        token: getToken()?.replace(/['"]+/g, ""),
        diagnostic_id: id,
      }
    )
    return { data: response }
  } catch (error) {
    return { error: error.response }
  }
}

export const getLabtestEmr = async (info) => {
  try {
    var payload = {
      // api_key: getQrApiKey(),
      requester: getUser(),
      token: getToken(),
      term: info?.term || "",
      parent_category_id: info?.parent_category_id || "",
      origin: "emr",
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_tests/get_for_emr",
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getLabCategories = async (info) => {
  try {
    var payload = {
      // api_key: getQrApiKey(),
      requester: getUser(),
      token: getToken(),
      origin: "emr",
      category_id: info?.category_id || "",
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "categories/get_parent",
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};

